import { render, staticRenderFns } from "./RankingsTableScrollingPublic.vue?vue&type=template&id=d4a08fde&scoped=true"
import script from "./RankingsTableScrollingPublic.vue?vue&type=script&lang=js"
export * from "./RankingsTableScrollingPublic.vue?vue&type=script&lang=js"
import style0 from "./RankingsTableScrollingPublic.vue?vue&type=style&index=0&id=d4a08fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a08fde",
  null
  
)

export default component.exports